"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemSettingsProvider = void 0;
exports.useSystemSetting = useSystemSetting;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var date_fns_1 = require("date-fns");
var useIsMounted_1 = require("../useIsMounted/useIsMounted");
var utils_1 = require("../../utils");
var Context = (0, react_1.createContext)({
    systemSettings: new Map(),
    lastTimeFetched: new Map(),
    setSetting: function () { },
    updateTimeFetched: function () { },
});
var SystemSettingsProvider = function (_a) {
    var children = _a.children;
    var Provider = Context.Provider;
    var _b = (0, react_1.useState)(new Map()), systemSettings = _b[0], setSystemSettings = _b[1];
    var _c = (0, react_1.useState)(new Map()), lastTimeFetched = _c[0], setLastTimeFetched = _c[1];
    var setSetting = (0, react_1.useCallback)(function (setting) {
        setSystemSettings(function (prev) { return new Map(prev.set(setting.name, setting)); });
    }, []);
    var updateTimeFetched = (0, react_1.useCallback)(function (name) {
        setLastTimeFetched(function (prev) { return new Map(prev.set(name, new Date())); });
    }, []);
    return ((0, jsx_runtime_1.jsx)(Provider, { value: {
            lastTimeFetched: lastTimeFetched,
            systemSettings: systemSettings,
            setSetting: setSetting,
            updateTimeFetched: updateTimeFetched,
        }, children: children }));
};
exports.SystemSettingsProvider = SystemSettingsProvider;
function useSystemSetting(name, config) {
    var _this = this;
    var _a = (config || {}).allowAutomaticRefetch, allowAutomaticRefetch = _a === void 0 ? true : _a;
    var _b = (0, react_1.useContext)(Context), systemSettings = _b.systemSettings, lastTimeFetched = _b.lastTimeFetched, setSetting = _b.setSetting, updateTimeFetched = _b.updateTimeFetched;
    var setting = systemSettings.get(name);
    var lastTimeFetchedValue = lastTimeFetched.get(name);
    var wasFetchedWithin24Hours = !!lastTimeFetchedValue &&
        (0, date_fns_1.differenceInHours)(new Date(), lastTimeFetchedValue) < 24;
    var shouldFetch = setting == null || (!wasFetchedWithin24Hours && allowAutomaticRefetch);
    var _c = (0, react_1.useState)(shouldFetch), isLoading = _c[0], setIsLoading = _c[1];
    var checkIsMounted = (0, useIsMounted_1.useIsMounted)();
    var fetchSystemSetting = (0, react_1.useCallback)(function (name) {
        var fetchSetting = function (name) { return __awaiter(_this, void 0, void 0, function () {
            var setting_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        return [4 /*yield*/, (0, utils_1.doGet)("/system-settings?name=".concat(name))];
                    case 1:
                        setting_1 = _a.sent();
                        if (checkIsMounted()) {
                            updateTimeFetched(name);
                            setSetting(setting_1);
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Error fetching system setting.', error_1);
                        return [3 /*break*/, 4];
                    case 3:
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        setIsLoading(true);
        fetchSetting(name);
    }, [checkIsMounted, setSetting, updateTimeFetched]);
    var value = (0, react_1.useMemo)(function () { return setting === null || setting === void 0 ? void 0 : setting.value; }, [setting]);
    (0, react_1.useEffect)(function () {
        if (shouldFetch) {
            fetchSystemSetting(name);
        }
    }, [fetchSystemSetting, name, shouldFetch]);
    var refetch = function () { return fetchSystemSetting(name); };
    return { value: value, isLoading: isLoading, refetch: refetch };
}
